import React from 'react';
import Marketplace from '@/pages/Marketplace';

const MarketplaceUploadPage = () => {
  return (
    <div className="space-y-6" data-testid="marketplace-upload-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Marketplace</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">Upload a Listing</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            Create a listing for machines, tooling, materials, digital files, or CNC services.
          </p>
        </div>
      </div>
      <Marketplace />
    </div>
  );
};

export default MarketplaceUploadPage;
